import React, { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import Select from "react-tailwindcss-select";
// import { Radio } from "@material-tailwind/react";
import { Fragment } from "react";
import { QueryTypense } from "./Searchbar";
 
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import logo_publiqly_grande from './logo_publiqly_grande.jpg'

// export const tipos_contratos = [
//     { value: 1, label: '27 - Otros servicios' },
//     { value: 2, label: 'Decreto 092 de 2017' },
//     { value: 3, label: 'Servicios de aprovisionamiento' },
//   ]

 const tiposRaw = ['Consultoría',
 'Alquiler de edificios',
 'Ventas de muebles',
 'Acuerdo Marco',
 'Decreto 092 de 2017',
 'Arrendamiento Muebles',
 'Comisión',
 'ND',
 '27 - Otros servicios',
 'No Especificado',
 'Suministros',
 'Obra',
 'Interventoría',
 'Seguros',
 'Compraventa',
 'Concesión',
 'Servicios de aprovisionamiento',
'Todos']

// Sort the list of types of contracts
tiposRaw.sort()

// Iterate over the list of types of contracts and create a dictionary
// to map the types of contracts to the corresponding number
export const tipos_contratos = []
for (let i = 0; i < tiposRaw.length; i++) {
    let dicti = {"value": i, "label": tiposRaw[i]}

    // Save
    tipos_contratos.push(dicti)

}



  
// export const modalidades_contratacion = [
//     { value: 1, label: 'Contratación directa' },
//     { value: 2, label: 'Licitación pública'},
//     { value: 3, label: 'Contratación régimen especial' }
//   ]


const modalidadesRaw = [
'Enajenación de bienes con subasta',
'Mínima cuantía',
'Contratación régimen especial (con ofertas)',
'Seleccion Abreviada Menor Cuantia Sin Manifestacion Interes',
'Concurso de méritos con precalificación',
'Contratación directa',
// 'CCE-20-Concurso_Meritos_Sin_Lista_Corta_1Sobre',
// 'CCE-19-Concurso_Meritos_Con_Lista_Corta_1Sobre',
'Concurso de méritos abierto',
'Licitación Pública Acuerdo Marco de Precios',
'Selección Abreviada de Menor Cuantía',
'Contratación régimen especial',
'Enajenación de bienes con sobre cerrado',
'Solicitud de información a los Proveedores',
'Licitación pública Obra Publica',
'Contratación Directa (con ofertas)',
'Selección abreviada subasta inversa',
'Licitación pública']

// Sort the list of modalides of contracts
modalidadesRaw.sort()

// Iterate over the list of modalides of contracts and create a dictionary
// to map the modalides of contracts to the corresponding number
export const modalidades_contratacion = []
for (let i = 0; i < modalidadesRaw.length; i++) {
    let dicti = {"value": i, "label": modalidadesRaw[i]}
    modalidades_contratacion.push(dicti)
}



  const tipos_busquedas = [
    { value: "Descripción del contrato", label: "Descripción del contrato" },
    { value: "Entidad contratante", label: "Entidad contratante" },
    { value: "Contratista", label: "Contratista" },
    { value: "NIT del contratante", label: "NIT del contratante"},
    { value: "Documento del contratista", label: "Documento del contratista" },
    { value: "Nombre de persona", label: "Nombre de persona" }
  ];

// Create function to make a query given the dictionary search




export default function Sidebar({onSelected, onQuery, searchValue}){

    console.log("From SidebarChat.jsx:")
    console.log("searchValue: ", searchValue)
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
    setIsOpen(!isOpen);
    };

    const pageNumber = 1;

    console.log("Page number: ", pageNumber)


    // const [animal, setAnimal] = useState([options_list[0], options_list[1]]);

    const [tipo_busqueda, setTipoBusqueda] = useState(tipos_busquedas[0]);

    // Los siguientes dos estados deben coincidir con los de App.js

    // const [selected_tipo, setSelectedTipo] = useState([tipos_contratos[0], tipos_contratos[1]])
    const [selected_tipo, setSelectedTipo] = useState([{ value: 0, label: 'Todos'}])

    const [selected_modalidad, setSelectedModalidad] = useState([modalidades_contratacion[3], modalidades_contratacion[11]])

    const dictionary_search = {
        tipo_busqueda: tipo_busqueda.value,
        tipo_de_contrato: selected_tipo.map((tipo) => tipo.label),
        modalidad_de_contratacion: selected_modalidad.map((tipo) => tipo.label)
    }

    console.log("Dictionary search: ", dictionary_search)
        

    const handleChangeBusqueda = value => {
        console.log("value CHANGED:", value);
        setTipoBusqueda(value);

        // Send the tipo de busqueda to the parent, which is in this case the App.jsx, and then to Searchbar.jsx
        // onSelected(value.value);

        // Change the value of the dictionary
        dictionary_search.tipo_busqueda = value.value;

        // Send the dictionary to the parent
        console.log("Sending dictionary to parent from SidebarChat.jsx")
        onSelected(dictionary_search);




    };

    const handleChangeTipo = value => {
        console.log("value:", value);

        // Check if the value is null
        if (value == null){
            value = [{ value: 0, label: 'Todos' }]
        }


        setSelectedTipo(value);

        // Change the value of the dictionary
        dictionary_search.tipo_de_contrato = value.map((tipo) => tipo.label);

        // Send the dictionary to the parent
        onSelected(dictionary_search);

        // Make query to Typensense
        console.log("searchValue:", searchValue)
        console.log("Making search from SidebarChat.jsx")
        QueryTypense(searchValue, dictionary_search, onQuery, pageNumber);


    };

    const handleChangeModalidad = value => {
        console.log("value:", value);
        

        // Check if the value is null
        if (value == null){
            value = [{ value: 0, label: 'Todos' }]
        }

        setSelectedModalidad(value);

        // Change the value of the dictionary
        dictionary_search.modalidad_de_contratacion = value.map((tipo) => tipo.label);

        // Send the dictionary to the parent
        onSelected(dictionary_search);

        // Make query to Typensense
        console.log("searchValue:", searchValue)
        console.log("Making search from SidebarChat.jsx")
        QueryTypense(searchValue, dictionary_search, onQuery, pageNumber);

    };


    


  return (

    <div className="fixed top-0 left-0 z-50 w-96 h-full bg-white shadow-lg overflow-y-auto md:translate-x-0 translate-x-full transition-transform duration-300 ease-in-out">


        <div className="flex justify-between items-center h-16 px-6  pt-8  ">
            {/* <div class="flex justify-center"> */}
            {/* <span className=" text-gray-800 font-bold text-lg">MotorBR42</span> */}
            <a href="https://flowbite.com/">
              {/* <img src="/Users/estebanfelipecaceresgelvez/Downloads/logo_publiqly.png" class="h-6 mr-3 sm:h-9" alt="" /> */}
                <img src={logo_publiqly_grande} class="h-6 mr-3 sm:h-9" alt="logo" className="self-center place-items-center h-6 mr-3 sm:h-9"/>
                {/* <span className="self-center place-items-center text-xl font-semibold whitespace-nowrap dark:text-white">publiqly</span> */}
  
              {/* <span className="text-xl font-semibold whitespace-nowrap dark:text-white">publiqly</span> */}
          </a>

        </div>

        {/* For keeping it hidden */}
        <div className={`px-6 py-6 ${isOpen ? "block" : "hidden"} md:block`}>


            {/* For the line, tipo de busqueda */}
            <div className="pt-5 space-y-1.5 border-b border-gray-200 pb-6 text-sm font-medium text-black-900">

                {/* <label className="block text-gray-700 text-sm font-medium mb-1" htmlFor="select-dropdown">Buscar por</label> */}
                <span className=" text-gray-800 text-sm mt-4">Buscar por</span>
                <Select
                    value={tipo_busqueda}
                    onChange={handleChangeBusqueda}
                    options={tipos_busquedas}
                    
                />
            </div>


            <div className="flex justify-between pt-4">
                <span className=" text-gray-800 font-bold text-lg">Más filtros</span>

            </div>
            {/* Tipo de contrato */}
            <div className="pt-5 space-y-1.5 pb-6 text-sm font-medium text-gray-900">
                <span className=" text-gray-800 text-sm mt-2">Tipo de contrato</span>
                <Select
                    value={selected_tipo}
                    onChange={handleChangeTipo}
                    options={tipos_contratos}
                    isMultiple={true}
                    isSearchable={true}
                    placeholder="Selecciona una opción"
                    // formatGroupLabel={}
                />
            </div>


            {/* Tipo de contrato */}
            <div className="pt-2 space-y-1.5 pb-6 text-sm font-medium text-gray-900">
                <span className=" text-gray-800 text-sm mt-2">Modalidad de contratación</span>
                <Select
                    value={selected_modalidad}
                    onChange={handleChangeModalidad}
                    options={modalidades_contratacion}
                    isMultiple={true}
                    isSearchable={true}
                    placeholder="Selecciona una opción"
                />
            </div>



        </div>



    </div>
  );
};


